interface IRoutes {
  home: string
  loginReferer: string
  manufacturer: string
  manufacturerDetail: string
  campaign: string
  login: string
  cart: string
  wishlist: string
  search: string
  searchOur: string
  product: string
  about: string
  conditions: string
  b2b: string
  privacyPolicy: string
  cookies: string
  postage: string
  conditionsOfActions: string
  deliveryCost: string
  hiring: string
  contact: string
  suppliersRegistration: string
  suppliersPurchaseDocs: string
  vipCoupons: string
  vipCouponsPage: string
  sizesGrid: string
  account: string
  orderHistory: string
  orderDetail: string
  checkOrder: string
  cancelOrder: string
  return: string
  returnAdd: string
  returnSuccess: string
  returnDetail: string
  deliveryAddress: string
  deliveryPayment: string
  signUp: string
  registration: string
  forgottenPassword: string
  accountInfo: string
  accountAddAddress: string
  accountChangePassword: string
  accountNewsletter: string
  notFound: string
  internalServerError: string
  unauthorized: string
  shop: string
  impressum: string
  thankYou: string
  checkoutSuccess: string
  checkoutWait: string
  email: string
  top100: string
  gifts: string
  giftsProducts: string
  frogies: string
  valentineCollection: string
  valentineCampaign: string
  summerWithChildren: string
  christmas: string
  summer: string
  blog: string
  checkoutStandby: string
  campaignTwoPlusOne: string
  campaignParfums: string
  campaignSellOut: string
}

export const Routes: IRoutes = {
  login: '/login',
  loginReferer: '/login?referer=/',
  home: '/',
  manufacturer: '/manufacturer',
  manufacturerDetail: '/manufacturer-detail',
  campaign: '/campaign',
  cart: '/cart',
  wishlist: '/wishlist',
  search: '/search/',
  searchOur: '/search-our/',
  product: '/product',
  about: '/information/about',
  b2b: '/information/b2b',
  conditions: '/information/terms',
  cookies: '/information/cookies',
  postage: '/information/postage',
  deliveryCost: '/step1',
  hiring: '/hiring',
  privacyPolicy: '/information/privacy-policy',
  contact: '/contact',
  suppliersRegistration: '/suppliers/registration',
  suppliersPurchaseDocs: '/suppliers/purchase-docs',
  vipCoupons: '/vip-coupons',
  vipCouponsPage: '/vip-coupons/[[...slug]]',
  sizesGrid: '/information/sizes-grid',
  account: '/account',
  orderHistory: '/account/orders',
  orderDetail: '/account/orders/order',
  checkOrder: '/check-order',
  cancelOrder: '/cancel-order',
  return: '/return',
  returnAdd: '/account/orders/return/add',
  returnSuccess: '/account/orders/return/success',
  returnDetail: '/account/orders/return',
  deliveryAddress: '/step2',
  deliveryPayment: '/payment',
  signUp: '/register',
  registration: '/register',
  forgottenPassword: '/lost-password',
  accountInfo: '/account/edit',
  accountAddAddress: '/account/add',
  accountChangePassword: '/account/password',
  accountNewsletter: '/account/newsletter',
  notFound: '/404',
  internalServerError: '/error500',
  unauthorized: '/error401',
  shop: '/information/shop',
  impressum: '/information/impressum',
  thankYou: '/thank-you',
  checkoutSuccess: '/checkout-success',
  checkoutWait: '/checkout-wait',
  email: '/email',
  top100: '/topproducts',
  gifts: '/gifts',
  giftsProducts: '/gifts/products',
  frogies: '/landing-page/Frogies',
  valentineCollection: 'campaign/laska-laska-laska',
  valentineCampaign: 'campaign/love',
  summerWithChildren: '/campaign/leto-s-detmilp',
  christmas: '/christmas',
  summer: '/summer',
  blog: '/blog',
  checkoutStandby: '/checkout-standby',
  conditionsOfActions: '/information/conditions-of-actions',
  campaignTwoPlusOne: '/campaign/trending-trendyol',
  campaignParfums: '/campaign/852',
  campaignSellOut: '/campaign/247'
}

// be aware that it won't match pages like /[...slug]
export const FocusRoutes = {
  basic: [Routes.deliveryCost, Routes.deliveryAddress],
  basicTower: [Routes.cart, Routes.deliveryCost, Routes.deliveryAddress],
  full: [
    Routes.notFound,
    Routes.internalServerError,
    Routes.unauthorized,
    '/_error',
    Routes.email,
    Routes.suppliersRegistration,
    Routes.vipCouponsPage
  ]
}
